export let RESELLER_ITEM_STATUSES = /*#__PURE__*/function (RESELLER_ITEM_STATUSES) {
  RESELLER_ITEM_STATUSES["REFUNDED"] = "REFUNDED";
  RESELLER_ITEM_STATUSES["CANCELLED"] = "CANCELLED";
  RESELLER_ITEM_STATUSES["REJECTED"] = "REJECTED";
  RESELLER_ITEM_STATUSES["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  RESELLER_ITEM_STATUSES["COLORS_REVIEW_BY_RESELLER"] = "COLORS_REVIEW_BY_RESELLER";
  RESELLER_ITEM_STATUSES["COLORS_REVIEW_BY_CUSTOMER"] = "COLORS_REVIEW_BY_CUSTOMER";
  RESELLER_ITEM_STATUSES["PROCESSING_ORDER"] = "PROCESSING_ORDER";
  RESELLER_ITEM_STATUSES["CREATING_PRODUCTION_MOCKUP"] = "CREATING_PRODUCTION_MOCKUP";
  RESELLER_ITEM_STATUSES["MOCKUP_APPROVAL_BY_RESELLER"] = "MOCKUP_APPROVAL_BY_RESELLER";
  RESELLER_ITEM_STATUSES["MOCKUP_REVISION_BY_RESELLER"] = "MOCKUP_REVISION_BY_RESELLER";
  RESELLER_ITEM_STATUSES["MOCKUP_APPROVAL_BY_CUSTOMER"] = "MOCKUP_APPROVAL_BY_CUSTOMER";
  RESELLER_ITEM_STATUSES["MOCKUP_REVISION_BY_CUSTOMER"] = "MOCKUP_REVISION_BY_CUSTOMER";
  RESELLER_ITEM_STATUSES["IN_PRODUCTION"] = "IN_PRODUCTION";
  RESELLER_ITEM_STATUSES["SHIPPED"] = "SHIPPED";
  RESELLER_ITEM_STATUSES["DELIVERED_TO_WAREHOUSE"] = "DELIVERED_TO_WAREHOUSE";
  RESELLER_ITEM_STATUSES["READY_FOR_DISTRIBUTION"] = "READY_FOR_DISTRIBUTION";
  RESELLER_ITEM_STATUSES["DELIVERED"] = "DELIVERED";
  return RESELLER_ITEM_STATUSES;
}({});
export let REVIEW_REQUEST_SEND_TO = /*#__PURE__*/function (REVIEW_REQUEST_SEND_TO) {
  REVIEW_REQUEST_SEND_TO["CUSTOMER"] = "CUSTOMER";
  REVIEW_REQUEST_SEND_TO["RESELLER"] = "RESELLER";
  return REVIEW_REQUEST_SEND_TO;
}({});